export default __webpack_public_path__ + "static/media/bh10.674a7428.jpg";